import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function briefsReducer(state = initialState.briefs, action){
    let briefsObject = {};
    switch(action.type){
      case types.BRIEF_SUCCESS:
      return action.briefs;
      default:
      return state;
    }
}
